import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { isValidPhoneNumber } from 'libphonenumber-js';
import AppInputError from './input-error';

interface PhoneNumberInputProps {
  phone: string;
  onPhoneChange: (value: string) => void;
  onPhoneValidCheck?: (valid: boolean) => void;
  label?: string;
  required?: boolean;
  errorMessage?: string;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  phone,
  onPhoneChange,
  onPhoneValidCheck,
  required,
  ...props
}) => {
  const [error, setError] = useState<string | null>(null);

  const handlePhoneChange = (value: string, countryData: any) => {
    const fullPhoneNumber = `+${value}`;

    // Validate using libphonenumber-js
    const isValid = isValidPhoneNumber(fullPhoneNumber);
    if (onPhoneValidCheck) {
      onPhoneValidCheck(isValid);
    }

    if (!isValid) {
      setError(`Invalid phone number for ${countryData?.name}`);
    } else {
      setError(null);
    }

    onPhoneChange(value); // Pass the phone number up to the parent
  };

  return (
    <div>
      {props.label ? (
        <div className="mb-1 flex items-center gap-2">
          <p className="font-semibold text-xs">{props.label}</p>
          {required ? <p className="text-red-500 mt-1"> *</p> : null}
        </div>
      ) : null}

      <div className="-mt-1">
        <PhoneInput
          country={'ng'} // Default country
          value={phone}
          onChange={(value, countryData) =>
            handlePhoneChange(value, countryData)
          }
          placeholder="Enter your phone number"
          inputStyle={{
            width: '100%',
            borderRadius: '0.5rem',
            border: '0',
            padding: '22px 3.5rem 24.5px',
            backgroundColor: props.errorMessage ? '#FEF2F2' : '#FAFAFA', // bg-red-50 : default bg
            fontSize: '16px',
            color: '#54555A',
          }}
          buttonStyle={{
            borderRadius: '8px 0 0 8px',
            border: '0',
            backgroundColor: props.errorMessage ? '#FEF2F2' : '#FAFAFA', // bg-red-50 : default bg
            borderRight: 'none',
            paddingLeft: '0.5rem',
          }}
          dropdownStyle={{
            borderRadius: '0 0 8px 8px',
            border: '1px solid #e5e7eb',
          }}
        />
        {props.errorMessage && <AppInputError text={props.errorMessage} />}
      </div>
    </div>
  );
};

export default PhoneNumberInput;
